import { gql } from '@apollo/client';

const CREDENTIAL_FIELDS = gql`
  fragment CredentialFields on Credential {
    accessToken
    client
    expiry
    tokenType
    uid
  }
`;

export const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    email
    name
    nickname
  }
`;

export const CURRENT_USER = gql`
  ${USER_FIELDS}
  query CurrentUser {
    currentUser {
      ...UserFields
      clientUsers {
        client { id, name }
        admin
      }
    }
  }
`;

export const LOGIN = gql`
  ${CREDENTIAL_FIELDS}
  mutation UserLogin(
    $email: String!
    $password: String!
  ) {
    userLogin(
      email: $email
      password: $password
    ) {
      credentials {
        ...CredentialFields
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation UserLogout {
    userLogout {
      authenticatable {
        id
      }
    }
  }
`;

export const REGISTER_USER = gql`
  mutation RegisterUser ($input: RegisterUserInput!) {
    registerUser (input: $input) {
      user { id }
      errors { path, message }
    }
  }
`;

export const USER_STATUS = gql`
  query UserStatus(
    $email: String!
  ) {
    userStatus(
      email: $email
    )
  }
`;

export const CONFIRM_USER = gql`
  ${CREDENTIAL_FIELDS}
  mutation CorfirmUser (
    $password: String!
    $passwordConfirmation: String!
    $invitationToken: String!
  ) {
    confirmUser(
      password: $password
      passwordConfirmation: $passwordConfirmation
      invitationToken: $invitationToken
    ) {
      credentials {
        ...CredentialFields
      }
    }
  }
`;

export const SEND_PASSWORD_RESET = gql`
  mutation UserSendPasswordResetWithToken(
    $email: String!
    $redirectUrl: String!
  ) {
    userSendPasswordResetWithToken(
      email: $email
      redirectUrl: $redirectUrl
    ) {
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  ${CREDENTIAL_FIELDS}
  mutation UserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $resetPasswordToken: String!
  ) {
    userUpdatePasswordWithToken(
      password: $password
      passwordConfirmation: $passwordConfirmation
      resetPasswordToken: $resetPasswordToken
    ) {
      credentials {
        ...CredentialFields
      }
    }
  }
`;

export const LOGIN_WITH_TOKEN = gql`
  ${CREDENTIAL_FIELDS}
  mutation LoginWithToken($token: String!) {
    loginWithToken(token: $token) {
      credentials {
        ...CredentialFields
      }
    }
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword(
    $currentPassword: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    updatePassword(
      currentPassword: $currentPassword
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      errors { path, message }
    }
  }
`;
